import React from 'react';
import './Footer.css';

const Footer = () => {
    const instagramLink = "https://www.instagram.com/goats_karate/";
    const facebookLink = "https://www.facebook.com/profile.php?id=61578222267348";

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© {new Date().getFullYear()} Goats Karate Team Poznań. All rights reserved.</p>
        <div className="social-icons">
          <a
            href={instagramLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href={facebookLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
        </div>
        <img src="/images/footer_image.png" alt="Footer Graphic" className="footer-image" />
      </div>
    </footer>
  );
};

export default Footer;
